import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports

function AddComment() {
    this.defaultAttrs({
        addCommentSelector: '[data-comment-new-text]',
        commentActionsSelector: '[data-comment-new-actions]',
        commentCancelSelector: '[data-comment-new-cancel]',
    });

    this.activate = function() {
        this.select('addCommentSelector').attr('data-active', true);
        this.trigger('uiShowControls');
        this.trigger('uiScrollToTargetRequested');
    };

    this.deactivate = function() {
        this.select('addCommentSelector').removeAttr('data-active');
    };

    this.showControls = function() {
        this.select('commentActionsSelector').attr('data-active', true);
    };

    this.hideControls = function() {
        this.select('commentActionsSelector').removeAttr('data-active');
    };

    this.blurDeactivate = function() {
        if (this.select('addCommentSelector').val().length === 0) {
            this.trigger('uiDeactivateTextarea');
            this.trigger('uiHideControls');
        }
    };

    this.cancelComment = function() {
        this.trigger('uiDeactivateTextarea');
        this.trigger('uiHideControls');
        this.select('addCommentSelector').val(null);
    };

    this.after('initialize', function() {
        this.on('uiActivateTextarea', this.activate);
        this.on('uiDeactivateTextarea', this.deactivate);

        this.on('uiShowControls', this.showControls);
        this.on('uiHideControls', this.hideControls);

        this.on('click', {
            addCommentSelector: this.activate,
            commentCancelSelector: this.cancelComment,
        });
        this.on('focusout', {
            addCommentSelector: this.blurDeactivate,
        });
    });
}

export default defineComponent(AddComment);



// WEBPACK FOOTER //
// ./src/js/component_ui/add-comment.js